{
  "version": 1,
  "asset_id": "e095051d-6242-4d2a-a72e-391f32b57343",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/e095051d-6242-4d2a-a72e-391f32b57343/danny-main-logo.jpg",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/e095051d-6242-4d2a-a72e-391f32b57343/danny-main-logo.jpg",
  "original_filename": "danny-main-logo.jpg",
  "size": 105274,
  "content_type": "image/jpeg",
  "created_at": "2026-06-17T10:37:52Z"
}
